document.addEventListener('DOMContentLoaded', () => {
  class ProductHowto extends HTMLElement {
    constructor() {
      super();

      this.pageHandle = this.getAttribute('data-howto-page-handle');
      this.elModalContent = document.querySelector('.js-product-howto-modal-content');

      this.setModalOpenEvent();
    }

    setModalOpenEvent() {
      this.addEventListener('click', async () => {
        try {
          // SEO考慮して、モーダル展開時にページデータを取得する形にする。
          const pageData = await fetch(`/pages/${this.pageHandle}.json`);
          const pageDataJson = await pageData.json();
          const bodyHtml = pageDataJson.page?.body_html;
          if (bodyHtml) {
            this.elModalContent.innerHTML = bodyHtml;
            this.wrapElements(this.elModalContent);
            MicroModal.show('product-howto-modal');

            // モーダル内のコンテンツを最上部にスクロール（Safari対応）
            setTimeout(() => {
              const scrollableContent = document.querySelector('.js-product-howto-modal-content');
              if (scrollableContent) {
                scrollableContent.scrollTop = 0;
              }
            }, 50);
          } else {
            throw new Error('body_html is not found');
          }
        } catch (error) {
          // エラーが発生した場合は、従来のHow to ページに遷移させる。
          console.error(error);
          window.location.href = `/pages/zenjinrui`;
        }
      });
    }

    // pageとスタイルを合わせるため、theme.jsで実行されてるwrapElements関数と同様の処理を実行
    wrapElements(container) {
      // テーブルをスクロール可能にする
      const tableSelectors = '.rte table';
      const tables = container.querySelectorAll(tableSelectors);
      tables.forEach((table) => {
        this.wrap(table, 'rte__table-wrapper');
      });

      // iframeをレスポンシブにする(.rteのセレクタは外す)
      const iframeSelectors = 'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"], iframe#admin_bar_iframe';
      const frames = container.querySelectorAll(iframeSelectors);
      frames.forEach((frame) => {
        this.wrap(frame, 'rte__video-wrapper');
      });
    }

    // wrap関数（theme.jsと同様）
    wrap(element, className) {
      const wrapper = document.createElement('div');
      wrapper.className = className;
      element.parentNode.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    }
  }

  customElements.define('product-howto', ProductHowto);
});